'use strict';

import type { UserBlitz } from '../../Entities/User/UserBlitz';
import { EntityCollection } from '../EntityCollection';

export class UserBlitzCollection extends EntityCollection<UserBlitz> {}
